module.exports = __webpack_public_path__ + "static/media/FlyBirdsBox_RoseGold_Icons-linkedin.b3adaf9f.png";